import { render, staticRenderFns } from "../routes/routesForm.html?vue&type=template&id=741dba1e&scoped=true&external"
import script from "../routes/routesForm.js?vue&type=script&lang=js&external"
export * from "../routes/routesForm.js?vue&type=script&lang=js&external"
import style0 from "../routes/routesForm.css?vue&type=style&index=0&id=741dba1e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741dba1e",
  null
  
)

export default component.exports